import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterHorizontal20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconGutterHorizontal20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.25 4.5a.75.75 0 0 0 0-1.5H16a2.5 2.5 0 0 0-2.5 2.5v9.002a2.5 2.5 0 0 0 2.5 2.5h.25a.75.75 0 0 0 0-1.5H16a1 1 0 0 1-1-1V5.5a1 1 0 0 1 1-1zM10 5.004a.75.75 0 0 1 .75.75v8.496a.75.75 0 0 1-1.5 0V5.754a.75.75 0 0 1 .75-.75M2.997 16.252a.75.75 0 0 1 .75-.75h.25a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1h-.25a.75.75 0 1 1 0-1.5h.25a2.5 2.5 0 0 1 2.5 2.5v9.002a2.5 2.5 0 0 1-2.5 2.5h-.25a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterHorizontal20);
